<script setup lang="ts">
import type { PostData } from '@/types';
import Blocks from '@/components/content-blocks/ContentBlocks.vue';
import StandardPage from '@/content-types/standard-page/StandardPage.vue';
import AnalysisHeader from './AnalysisHeader.vue';
import AnalysisFooter from './AnalysisFooter.vue';

defineProps<{
  postData: PostData;
}>();
</script>

<template>
  <StandardPage>
    <main class="page-content">
      <AnalysisHeader
        :title="postData.title"
        :published-on="postData.publishedOn"
        :authors="postData.authors"
        :standfirst="postData.standfirst"
      />
      <Blocks :blocks="postData.blocks" />
      <AnalysisFooter
        :authors="postData.authors"
      />
    </main>
  </StandardPage>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/shared/screen" as screen;

.page-content {
  position: relative;
  padding-top: var(--spacing-xl);
  display: grid;
  grid-template: "container";
  align-items: start;

  color: var(--colour-dark-grey);
  background: linear-gradient(180deg, var(--colour-off-white) 0 75rem, #fff 75rem 100%);

  @include screen.respond(tablet) {
    display: block;
    padding-left: 4.8rem; // add extra padding as a stopgap for too-wide layout on large tablets
    padding-right: 4.8rem;
  }

  @include screen.respond(mobile) {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
